import { Trans } from "@lingui/macro";
import { UiDialogResponsive } from "@smp/ui";
import { useState } from "react";

import { Prepare } from "./prepare";
import { Success } from "./success";

export const DialogGetPosts = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [step, setStep] = useState<"prepare" | "success">("prepare");

  const handleSuccess = () => setStep("success");

  return (
    <UiDialogResponsive
      fullWidth
      onClose={onClose}
      open={open}
      title={<Trans>Get free posts</Trans>}
    >
      {step === "prepare" && (
        <Prepare onClose={onClose} onSuccess={handleSuccess} />
      )}
      {step === "success" && <Success />}
    </UiDialogResponsive>
  );
};
